import { AxiosResponse } from 'axios';
import { api } from './config';
import { ApiResponse } from '../types';

/**
 * FormData 생성 헬퍼
 * null/undefined 값을 자동으로 필터링합니다.
 */
export const createFormData = (data: Record<string, any>): FormData => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, item);
        });
      } else {
        formData.append(key, String(value));
      }
    }
  });
  return formData;
};

/**
 * Multipart POST 요청 헬퍼
 * FormData를 자동으로 생성하여 전송합니다.
 */
export const postMultipart = <T = any>(
  url: string,
  data: Record<string, any>,
  onProgress?: (percentCompleted: number) => void
): Promise<AxiosResponse<ApiResponse<T>>> => {
  const formData = createFormData(data);
  return api.post<ApiResponse<T>>(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percentCompleted);
      }
    },
  });
};

/**
 * 파일 업로드 헬퍼 (특정 URL로)
 */
export const uploadFileToUrl = <T = any>(
  url: string,
  file: File,
  additionalData?: Record<string, any>,
  onProgress?: (percentCompleted: number) => void
): Promise<AxiosResponse<ApiResponse<T>>> => {
  return postMultipart<T>(url, { file, ...additionalData }, onProgress);
};

// Legacy file upload helper (for backward compatibility)
export const uploadFile = async (
  file: File,
  onProgress?: (percentCompleted: number) => void
): Promise<AxiosResponse<ApiResponse>> => {
  return uploadFileToUrl('/upload', file, undefined, onProgress);
};

// Format error message from API response
export const getErrorMessage = (error: any): string => {
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  if (error.response?.data?.details) {
    return error.response.data.details.map((d: any) => d.msg).join(', ');
  }
  if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};
